import { z } from 'zod'

export const paramsSchema = z.object({
  id: z.string(),
  dateIn: z.string(),
  dateOut: z.string(),
  numPeople: z.number().int().nullable(),
})

export type paramsType = z.infer<typeof paramsSchema>
